exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".paddingTop--cfCUC{width:100%;margin-top:7px}\n", "", {"version":3,"sources":["/workspace/src/widget/new-event-layouts/shared/top_padder/styles.scss"],"names":[],"mappings":"AAAA,mBACE,WACA,cAAe,CAAA","file":"styles.scss","sourcesContent":[".paddingTop {\n  width: 100%;\n  margin-top: 7px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"paddingTop": "paddingTop--cfCUC"
};